



// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Components
import Icon, { IconEnum } from "@/shared/components/icon.component.vue";

// Models
import { PurchaseLine } from "@/clickbuy/purchase/models/purchase-line.model";

// Services
import UtilsService from "@/core/services/utils.service";

// Filters
import round from "@/shared/filters/round.filter.ts";

export enum LineColor {
  Primary = "line--primary",
  Secondary = "line--secondary",
  Gold = "line--gold",
}

@Component({
  components: {
    Icon
  },
  computed: {
    ...mapGetters({
      currentPurchase: "getCurrentPurchase",
      purchaseFinished: "currentPurchaseFinished"
    })
  },
  filters: {
    round
  }
})
export default class ShoppingCartLine extends Vue {
  @Prop() private line!: any;
  @Prop({ default: false }) private modeModal!: boolean;

  private iconEnum = IconEnum;
  private currentPurchase!: any;

  get lineTitle() {
    let title = "";
    if (this.line.gift) {
      title = "Regalo";
    } else if (
      this.line.repeater &&
      this.line.product &&
      this.line.product.level
    ) {
      title = `REP · Nivel ${this.line.product.level}`;
    } else if (
      this.line.product &&
      this.line.product.level &&
      this.line.product.formativeBranch
    ) {
      title = `Nivel ${this.line.product.level}`;
    } else if (
      this.line.product &&
      this.line.product.acronym &&
      this.line.product.acronym.includes("TLP")
    ) {
      title = "TLP";
    } else if (this.line.product && !this.line.product.formativeBranch) {
      title = "Especialización";
    }
    return title;
  }

  get lineSubtitle() {
    let subtitle = this.line.productName;
    if (this.line.product) {
      subtitle = (this.line as any).product.name;
    }
    return subtitle;
  }

  get isFree() {
    return Number(this.line.totalPrice) === 0;
  }

  get lineFinalPrice() {
    let finalPrice = this.line.totalPrice;
    if (this.line.product && this.line.product.reserve > 0) {
      if (this.line.price && !this.line.product.tax) {
        finalPrice =
          this.line.price * this.line.amount
      } else {
        finalPrice =
          this.line.totalPrice * this.line.amount +
          (this.line.paymentPending || 0);
        // finalPrice =
        //   this.line.product.reserve * this.line.amount +
        //   (this.line.paymentPending || 0);
      }
    }
    return finalPrice;
  }

  get showRemoveIcon() {
    return !this.modeModal && !this.line.gift;
  }

  private removeLine() {
    const index = this.currentPurchase.purchaseLines.indexOf(this.line);
    this.currentPurchase.purchaseLines.splice(index, 1);
  }
}
